import { combineReducers } from 'redux';
import { orderReducer } from './order';
import { loginReducer } from './login';
import { userReducer } from './user';
import { usersReducer } from './users';
import { transactionsReducer } from './transactions';
import { customersReducer } from './customers';
import { permissionsReducer } from './permissions';
import { rolesReducer } from './roles';
import { paymentInterfaceReducer } from './paymentInterface';
import { addressAnnotationReducer } from './addressAnnotation';
import { merchantListReducer } from './merchantList';
import { paymentProviderReducer } from './paymentProvider';
import { utmListReducer } from './utmList';

const reduxState = combineReducers({
  order: orderReducer,
  login: loginReducer,
  user: userReducer,
  users: usersReducer,
  transactions: transactionsReducer,
  customers: customersReducer,
  permissions: permissionsReducer,
  roles: rolesReducer,
  paymentInterface: paymentInterfaceReducer,
  addressAnnotation: addressAnnotationReducer,
  merchantList: merchantListReducer,
  paymentProviders: paymentProviderReducer,
  utms: utmListReducer,
});

export default reduxState;
